import { render, staticRenderFns } from "./DisenchantmentCollectionLayout.vue?vue&type=template&id=ae4276b0&"
import script from "./DisenchantmentCollectionLayout.vue?vue&type=script&lang=js&"
export * from "./DisenchantmentCollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae4276b0')) {
      api.createRecord('ae4276b0', component.options)
    } else {
      api.reload('ae4276b0', component.options)
    }
    module.hot.accept("./DisenchantmentCollectionLayout.vue?vue&type=template&id=ae4276b0&", function () {
      api.rerender('ae4276b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/Guides/DisenchantmentCollectionLayout.vue"
export default component.exports